import React from "react";
import {
  get_Date,
  getSurveyStatusName,
  generateSurveyID,
} from "./commonFunctions";
import { AxiosConfiguration } from "./AxiosConfig";
import * as Constant from "./constants";
import { Link } from "react-router-dom";

export function active_component(props) {
  const full_path = window.location.href;
  const current_component = full_path.substring(full_path.lastIndexOf("/") + 1);
  let url = full_path.split("/");
  const currentComponent2 = url[url.length - 2];
  let dash_button_class_status = "btn btn-md btm-sm dash_inactive_button";
  let device_button_class_status = "btn btn-md bt-sm dash_inactive_button";
  let surveys_button_class_status = "btn btn-md bt-sm dash_inactive_button";
  if (
    current_component === "UserDashboard" ||
    currentComponent2 === "UserDashboard"
  ) {
    dash_button_class_status = "btn btn-md btm-sm dash_active_button";
    device_button_class_status = "btn btn-md btm-sm dash_inactive_button";
    surveys_button_class_status = "btn btn-md btm-sm dash_inactive_button";
  }

  if (current_component === "UserDevices") {
    dash_button_class_status = "btn btn-md dash_inactive_button";
    device_button_class_status = "btn btn-md dash_active_button";
    surveys_button_class_status = "btn btn-md dash_inactive_button";
  }
  if (current_component === "UserListSurveys") {
    dash_button_class_status = "btn btn-md dash_inactive_button";
    device_button_class_status = "btn btn-md dash_inactive_button";
    surveys_button_class_status = "btn btn-md dash_active_button";
  }

  return {
    button_dash: dash_button_class_status,
    button_devices: device_button_class_status,
    button_surveys: surveys_button_class_status,
  };
}

/*
  Purpose:    use to get user dashboard information
  Created By: Vinit Kumar 
*/
export const getUserDashboardInformation = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/manufacturer_dashboard/")
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get user dashboard information
  Created By: Vinit Kumar 
*/
export const getUserDeviceInformation = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/manufacturer_devices/")
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all survey devices list
  Created By: Vinit Kumar 
*/
export const getSurveyDevicesList = (deviceID) => {
  const bodyFormData = new FormData();
  bodyFormData.append("device_id", deviceID);
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/manufacturer_device_survey/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems;
        let surveyListObj = response.data.data.devices_survey_list;
        if (surveyListObj)
          optionItems = surveyListObj.map((item) => (
            <tr key={item.survey_id}>
              <td>
                <Link
                  to={"/UserSurveyDetails/" + item.survey_id}
                  style={{ textDecoration: "none" }}
                >
                  {item.survey_name}
                </Link>
              </td>
            </tr>
          ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td> No records found</td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all survey  list
  Created By: Vinit Kumar 
*/
export const getUserSurveyList = () => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/manufacturer_surveys/")
    .then((response) => {
      if (response.data.data) {
        let sr = 0;
        let surveyListObj = response.data.data.survey_list;
        let optionItems = surveyListObj.map((item) => (
          <tr key={item.survey_id}>
            <td>{++sr}</td>
            <td>
              <Link
                to={"/UserSurveyDetails/" + item.survey_id}
                style={{ textDecoration: "none" }}
              >
                {item.device__device_name}
              </Link>
            </td>

            <td>
              <Link
                to={"/UserSurveyDetails/" + item.survey_id}
                style={{ textDecoration: "none" }}
              >
                {generateSurveyID(item.site_id, item.survey_id)}
              </Link>
            </td>

            <td>
              <Link
                to={"/UserSurveyDetails/" + item.survey_id}
                style={{ textDecoration: "none" }}
              >
                {item.survey_name}
              </Link>
            </td>

            <td>{getSurveyStatusName(item.status)}</td>
            <td>{get_Date(item.created_date)}</td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={9}> {response.data.message}</td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get user survey information
  Created By: Vinit Kumar 
*/
export const getUserSurveyDetails = (surveyID) => {
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);

  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/manufacturer_survey_details/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get manufacturer participants
  Created By: Vinit Kumar 
*/
export const getUserSurveyManufacturerParticipants = (surveyID) => {
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/manufacturer_participants/", bodyFormData)
    .then((response) => {
      if (response.data) {
        let participantListObj = response.data.data[0].participants_records;
        let optionItems = participantListObj.map((item, i) => (
          <tr key={++i}>
            <td className="text-center">{++i}</td>
            <td>{item.first_name}</td>
            <td>{item.last_name}</td>
            <td>{item.email}</td>
            <td>{item.profession__profession_name}</td>
            <td>{item.region__region_name}</td>
            <td>{item.country__country_name}</td>
            <td>{item.contact}</td>
          </tr>
        ));
        return {
          status: "success",
          data: response.data.data,
          participantsList: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get survey preview by survey id
  Created By: Dinesh kumar 
*/
export const getUserSurveyFormPreview = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/manufacturer_survey_form_preview/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          data: results,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};
/* 
  Purpose:    Used to get participant qualification view for user
  Created By: Dinesh kumar 
*/
export const getUserParticipantQualificationView = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/survey_participant_qualification/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          getsurveyID: results[0].survey_id,
          getSurveyName: results[0].survey_name,
          getCompanyLogo: results[0].manufacturer__company_logo,
          getDeviceImage: results[0].device__device_image,
          getCompanyName: results[0].manufacturer__company_name,
          getParticipantQualificationJson:
            results[0].participant_qualification_json,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to get user survey Individual Responses
  Created By: Dinesh Kumar 
*/
export const getSurveyIndividualResponses = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_individualResponses/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:Use to get user landing page data
  Created By: Dinesh Kumar 
*/
export const getUserAnalysisChartData = (surveyID, per_page) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("per_page", per_page);
  return axiosInstance
    .post("v1/create_user_survey_analysis/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to get user analysis chart data and save chart info according to filter and question id by survey
  Created By: Dinesh Kumar 
*/
export const getUserAnalysisChartGenerate = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/build_user_survey_analysis_graph/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:   Use to get survey analysis preview for user
  Created By: Dinesh Kumar 
*/
export const getUserSurveyAnalysisPreview = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_user_analysis_preview/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Delete user preview chart function
  Created By: Dinesh Kumar 
*/
export const deleteUserAnalysisGraph = (surveyID, analysisID) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/delete_user_survey_analysis_graph/";
  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("user_analysis_id", analysisID);
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:Use to get user survey analysis download 
  Created By: Dinesh Kumar 
*/
export const getUserSurveyAnalysisDownload = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/download_user_analysis_preview/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to check primary user account activation link
  Created By: Dinesh Kumar 
*/
export const userAccountActivation = (user_id, reset_token) => {
  const bodyFormData = new FormData();
  bodyFormData.append("user_id", user_id);
  bodyFormData.append("reset_token", reset_token);
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/account_activation/", bodyFormData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to check primary user account activation link
  Created By: Dinesh Kumar 
*/
export const updateAccountActivationPassword = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/changePassword/", bodyFormData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to check primary user account reset passord link
  Created By: Dinesh Kumar 
*/
export const resetPassword = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/reset_password/", bodyFormData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to check primary user account reset passord link
  Created By: Dinesh Kumar 
*/
export const updateForgotPassword = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/passwordChange/", bodyFormData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Use to check primary user login auth
  Created By: Dinesh Kumar 
*/
export const LoginAuth = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/login/", bodyFormData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Regions list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getIndSurveyRegionList = (surveyId) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyId);
  return axiosInstance
    .post("v1/get_survey_participants_region/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        response.data.data.map((item) =>
          tmpValue.push({
            label: item.region_name,
            value: item.participant__region_id,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Countries list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getIndSurveyCountriesList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/get_participants_county/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        let tempObj = response.data.data;
        tempObj.map((item) =>
          tmpValue.push({
            label: item.country_name,
            value: item.country_id,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Profession list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getIndSurveyProfessionList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/get_participants_profession/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        let tempObj = response.data.data;
        tempObj.map((item) =>
          tmpValue.push({
            label: item.profession_name,
            value: item.profession_id,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    Use to get user and manufacture information
  Created By: Dinesh Kumar 
*/
export const getUserSettngs = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/user_settings/")
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};
/*
  Purpose:    Use to Update user information
  Created By: Dinesh Kumar 
*/
export const updateUserData = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/edit_user/", bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
        extra_data: response.data.extra_data,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:  Use to Update user password
  Created By: Dinesh Kumar 
*/
export const updateUserpassword = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("app/v1/user_password_change/", bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};
